import React, { useState } from 'react';
import CalendarView from '../components/calendar/CalendarView';
import { Link } from 'react-router-dom';
import { HiCog, HiSwitchHorizontal, HiOutlinePaperAirplane } from 'react-icons/hi';
import NotificationBell from '../components/notifications/NotificationBell';
import TripModal from '../components/custody/TripModal';
import { useFamily } from '../context/FamilyContext';

const CalendarPage = () => {
  const { isHouseholdMember } = useFamily();
  const [tripOpen, setTripOpen] = useState(false);

  return (
    <div className="animate-fade-in">
      <div className="flex items-center justify-between page-header">
        <div>
          <h1 className="page-title">Calendar</h1>
          <p className="page-subtitle">Click any day to propose a swap</p>
        </div>
        <div className="flex items-center gap-3">
          {!isHouseholdMember && (
            <button
              onClick={() => setTripOpen(true)}
              className="btn-primary flex items-center gap-2 text-sm"
            >
              <HiOutlinePaperAirplane className="rotate-45" />
              Plan a trip
            </button>
          )}
          <Link
            to="/swaps"
            className="btn-secondary flex items-center gap-2 text-sm"
          >
            <HiSwitchHorizontal />
            Swaps &amp; Trips
          </Link>
          <Link
            to="/custody/setup"
            className="btn-secondary flex items-center gap-2 text-sm"
          >
            <HiCog />
            Custody Settings
          </Link>
          <NotificationBell />
        </div>
      </div>
      {tripOpen && <TripModal onClose={() => setTripOpen(false)} />}
      <CalendarView />
    </div>
  );
};

export default CalendarPage;
